export const USER_CREATE_WALKTHROUGH = 'CREATE_WALKTHROUGH'
export const USER_CREATE_WALKTHROUGH_SUCCESS = 'BID_WALKTHROUGH_CREATE_WALKTHROUGH'
export const USER_COMPLETE_WALKTHROUGH_SUCCESS = 'BID_WALKTHROUGH_COMPLETE_WALKTHROUGH'
export const BID_WALKTHROUGH_DOWNLOAD_WALKTHROUGH = 'BID_WALKTHROUGH_DOWNLOAD_WALKTHROUGH'